import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import "./index.css"
import Footer from './components/Footer';


const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <ErrorBoundary fallback={<div>Application error - please refresh</div>}>
      <App />
    </ErrorBoundary>
    <Footer />

  </React.StrictMode>
);